import { ErrorWithToastData } from '@/exceptions/ErrorWithToastData';
import {
  MAX_LENGTH_CONSTRAINT,
  MIN_LENGTH_CONSTRAINT
} from '@/models/doc-review';
import { OfficeUtils } from '@/utils/office.utils';
import { formatNumber } from '@/utils/utils';

export const DocumentValidationUtils = {
  /**
   * Validates if the document meets the requirements for reviewing
   * @param t - Translation function from vue-i18n
   * @throws {ErrorWithToastData} If the document doesn't meet the requirements
   */
  async validateReviewRequirements(
    t: (key: string, values?: Record<string, unknown>) => string
  ): Promise<void> {
    const numberOfWords = await OfficeUtils.getDocumentWordCount();

    const minLength = Number(
      process.env.VUE_APP_REVIEW_REQ_MIN_LENGTH ?? MIN_LENGTH_CONSTRAINT
    );
    const maxLength = Number(
      process.env.VUE_APP_REVIEW_REQ_MAX_LENGTH ?? MAX_LENGTH_CONSTRAINT
    );

    if (numberOfWords < minLength || numberOfWords > maxLength) {
      throw new ErrorWithToastData(
        t('home.review.validation_error.title'),
        t('home.review.validation_error.body', {
          min: formatNumber(minLength),
          max: formatNumber(maxLength),
          current: formatNumber(numberOfWords)
        })
      );
    }
  }
};
